import { fetchEndpoint } from "../network";

/**
 * 话题管理
 */
export function list(params) {
  return fetchEndpoint("/contentTopic/list", "GET", params);
}
export function add(params) {
  return fetchEndpoint("/contentTopic/insert", "post", params);
}
export function modify(params) {
  return fetchEndpoint("/contentTopic/update", "post", params);
}
export function deleteItems(params) {
  return fetchEndpoint("/contentTopic/delete", "get", params);
}
export function state(params) {
  return fetchEndpoint("/content/updateBatch", "post", params);
}

export function contentList(params) {
  return fetchEndpoint("/contentTopic/contentList", "get", params);
}
export function contentTop(params) {
  return fetchEndpoint("/contentTopic/contentTop", "post", params);
}
export function addComment(params) {
  return fetchEndpoint("/comment/add", "post", params);
}
